import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { debounce } from '../../utils';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input as AntInput,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
  Table,
} from 'antd';
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorPracticeCenters,
  updatePracticeCenter,
  removePracticeForDoctor,
  fetchCenters,
  sendRequestForDoctorDetailsChanges,
  getDoctorPriceHistory,
} from '../../services';

const { Paragraph, Text, Title } = Typography;
const { Option } = Select;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const PracticeText = styled(RegularText)`
  font-size: 14;
  color: #666569;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: column;
`;

const StatusDot = styled.div`
  float: left;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: ${(props) => props.color || 'black'};
`;

// const Row = styled.div`
//   display: flex;
//   flex-direction: row;
// `;

// const Col = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   margin-right: 10px;
// `;

const columns = [
  {
    title: 'RequestId',
    dataIndex: 'requestId',
    key: 'requestId',
  },
  {
    title: 'Old OPD Charges',
    dataIndex: 'oldOpdCharges',
    key: 'oldOpdCharges',
  },
  {
    title: 'New OPD Charges',
    dataIndex: 'newOpdCharges',
    key: 'newOpdCharges',
  },
  {
    title: 'Old Offline Discount',
    dataIndex: 'oldOfflineDiscount',
    key: 'oldOfflineDiscount',
  },
  {
    title: 'New Offline Discount',
    dataIndex: 'newOfflineDiscount',
    key: 'newOfflineDiscount',
  },
  {
    title: 'Old Offline Follow Up Days',
    dataIndex: 'oldofflineFollowUpDays',
    key: 'oldofflineFollowUpDays',
  },
  {
    title: 'New Offline Follow Up Days',
    dataIndex: 'newofflineFollowUpDays',
    key: 'newofflineFollowUpDays',
  },
  {
    title: 'Old Follow Up Offline Discount',
    dataIndex: 'oldOfflineFollowUpDiscount',
    key: 'oldOfflineFollowUpDiscount',
  },
  {
    title: 'New Follow Up Offline Discount',
    dataIndex: 'newOfflineFollowUpDiscount',
    key: 'newOfflineFollowUpDiscount',
  },
  {
    title: 'Request Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },
];
class DoctorPracticeCenterScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      practiceCenters: [],
      doctorPracticeId: null,
      networkCenterId: null,
      doctorPracticeActive: false,
      isRequestFromPluton: false,
      networkCenterTitle: '',
      networkCenterLocality: '',
      networkCenterStatus: 'not-live',
      emergencyNumber: '',
      opdCharges: '',
      onlineOpdCharges: '',
      previousOpdCharges: '',
      previousOnlineOpdCharges: '',
      priceChangeReason: '',
      inputReason: '',
      onlineDiscountOperation: 'percentage',
      onlineDiscount: '',
      offlineDiscountOperation: 'percentage',
      offlineDiscount: '',
      fDiscountOperation: 'percentage',
      fDiscount: '',
      fDays: '0',
      onlineFDiscountOperation: 'percentage',
      onlineFDiscount: '',
      onlineFDays: '0',
      payoutTo: 'center',
      formEditing: false,
      formSaving: false,
      addCenterModalVisible: false,
      addedHealthCenter: { key: '', label: '' },
      fetchingCenters: false,
      fetchedHealthCenters: [],
      previousData: {},
      addingNewCenter: false,
      telehealth: false,
      previousTelehealth: false,
      previousDoctorPracticeActive: false,
      showingPriceHistory: false,
      doctorPriceHistory: [],
    };
    console.log({ props });

    this.doctorId = props.doctorId;
    this.debouncedFetchHealthCenters = debounce(this.fetchHealthCenters, 600);
  }

  componentDidMount = () => {
    this.fetchPractice();
  };

  fetchPractice = () => {
    const { dispatch } = this.props;
    fetchDoctorPracticeCenters(this.doctorId)
      .then((res) => {
        const practiceCenters = res.practices;
        dispatch(setDoctorProfile({ practiceCenters }));
        this.setState({
          practiceCenters,
        });
      })
      .finally(() => this.setState({ loading: false }));
  };

  submit = () => {
    const {
      networkCenterId,
      doctorPracticeActive,
      opdCharges,
      onlineOpdCharges,
      previousOnlineOpdCharges,
      previousOpdCharges,
      priceChangeReason,
      offlineDiscount,
      offlineDiscountOperation,
      onlineDiscount,
      onlineDiscountOperation,
      fDiscount,
      fDiscountOperation,
      fDays,
      onlineFDiscount,
      onlineFDiscountOperation,
      onlineFDays,
      payoutTo,
      networkCenterStatus,
      onlineCorporatePayout,
      onlineRetailPayout,
      telehealth,
      previousTelehealth,
      previousDoctorPracticeActive,
      addingNewCenter,
      previousData,
    } = this.state;
    if (
      !addingNewCenter &&
      !priceChangeReason &&
      previousDoctorPracticeActive == doctorPracticeActive &&
      previousTelehealth == telehealth &&
      previousOnlineOpdCharges == onlineOpdCharges &&
      previousData.onlineDiscount == onlineDiscount &&
      previousData.onlineDiscountOperation == onlineDiscountOperation &&
      previousData.onlineFDiscount == onlineFDiscount &&
      previousData.onlineFDiscountOperation == onlineFDiscountOperation &&
      previousData.onlineFDays == onlineFDays
    ) {
      alert('Please enter price change reason!');
      return;
    }
    this.setState({ formSaving: true });
    console.log(previousDoctorPracticeActive, doctorPracticeActive);
    console.log(previousTelehealth, telehealth);
    console.log(previousOnlineOpdCharges, onlineOpdCharges);
    console.log(previousTelehealth, telehealth);
    console.log(previousData, onlineDiscount, onlineDiscount, onlineDiscountOperation, onlineFDiscount, onlineFDiscountOperation, onlineFDays);

    if (addingNewCenter) {
      updatePracticeCenter({
        doctorId: this.doctorId,
        centerId: networkCenterId,
        active: doctorPracticeActive,
        opdCharges,
        onlineOpdCharges,
        offlineDiscount,
        offlineDiscountOperation,
        onlineDiscount,
        onlineDiscountOperation,
        fDiscount,
        fDiscountOperation,
        fDays,
        onlineFDiscount,
        onlineFDiscountOperation,
        onlineFDays,
        fulfilmentType: payoutTo,
        status: networkCenterStatus,
        onlineCorporatePayout,
        onlineRetailPayout,
        telehealth,
      })
        .then(() => {
          this.cancelEditing();
          this.fetchPractice();
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          this.setState({ formSaving: false });
        });
    } else if (
      (previousDoctorPracticeActive !== doctorPracticeActive ||
      previousTelehealth !== telehealth ||
      previousOnlineOpdCharges !== onlineOpdCharges ||
      previousData.onlineDiscount !== onlineDiscount ||
      previousData.onlineDiscountOperation !== onlineDiscountOperation ||
      previousData.onlineFDiscount !== onlineFDiscount ||
      previousData.onlineFDiscountOperation !== onlineFDiscountOperation ||
      previousData.onlineFDays !== onlineFDays) && (opdCharges == previousData.opdCharges)
    ) {
      updatePracticeCenter({
        doctorId: this.doctorId,
        centerId: networkCenterId,
        active: doctorPracticeActive,
        opdCharges: previousData.opdCharges,
        onlineOpdCharges: onlineOpdCharges,
        offlineDiscount: previousData.offlineDiscount,
        offlineDiscountOperation: previousData.offlineDiscountOperation,
        onlineDiscount: onlineDiscount,
        onlineDiscountOperation: onlineDiscountOperation,
        fDiscount: previousData.fDiscount,
        fDiscountOperation: previousData.fDiscountOperation,
        fDays: previousData.fDays,
        onlineFDiscount: onlineFDiscount,
        onlineFDiscountOperation: onlineFDiscountOperation,
        onlineFDays: onlineFDays,
        fulfilmentType: previousData.fulfilmentType,
        status: previousData.status,
        onlineCorporatePayout,
        onlineRetailPayout,
        telehealth,
      })
        .then(() => {
          this.cancelEditing();
          this.fetchPractice();
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          this.setState({ formSaving: false });
        });
    } else {
      sendRequestForDoctorDetailsChanges({
        doctorId: this.doctorId,
        centerId: networkCenterId,
        active: doctorPracticeActive,
        opdCharges,
        onlineOpdCharges,
        offlineDiscount,
        offlineDiscountOperation,
        onlineDiscount,
        onlineDiscountOperation,
        fDiscount,
        fDiscountOperation,
        fDays,
        onlineFDiscount,
        onlineFDiscountOperation,
        onlineFDays,
        fulfilmentType: payoutTo,
        status: networkCenterStatus,
        onlineCorporatePayout,
        onlineRetailPayout,
        telehealth,
        priceChangeReason:
          priceChangeReason === 'Other'
            ? this.state.inputReason
            : priceChangeReason,
        previousData,
        requestType: 'Price-Change-Request',
      })
        .then(() => {
          this.cancelEditing();
          this.fetchPractice();
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          this.setState({ formSaving: false });
        });
    }
  };

  // deletePractice = doctorPracticeId => {
  //   deletePractice(this.doctorId, doctorPracticeId)
  //     .then(res => {
  //       message.success('Practice deleted successfully');
  //       this.fetchPractice();
  //     })
  //     .catch(err => {
  //       console.log({ err });
  //     });
  // };

  editPractice = (edu) => {
    this.setState({
      formEditing: true,
      doctorPracticeId: edu.doctorId || null,
      networkCenterId: edu.centerId || null,
      doctorPracticeActive: edu.active === 1,
      networkCenterTitle: edu.centerName || '',
      networkCenterLocality: edu.centerLocation || '',
      networkCenterStatus: edu.status || 'pending',
      opdCharges: edu.opdCharges || 0,
      onlineOpdCharges: edu.onlineOpdCharges || 0,
      previousOpdCharges: edu.opdCharges || 0,
      previousOnlineOpdCharges: edu.onlineOpdCharges || 0,
      offlineDiscountOperation: edu.offlineDiscountOperation || 'percentage',
      offlineDiscount:
        (edu.offlineDiscount !== null &&
          edu.offlineDiscount !== undefined &&
          edu.offlineDiscount) ||
        0,
      onlineDiscountOperation: edu.onlineDiscountOperation || 'percentage',
      onlineDiscount:
        (edu.onlineDiscount !== null &&
          edu.onlineDiscount !== undefined &&
          edu.onlineDiscount) ||
        0,
      fDiscountOperation: edu.fDiscountOperation || 'percentage',
      onlineFDiscountOperation: edu.onlineFDiscountOperation || 'percentage',
      fDiscount:
        (edu.fDiscount !== null &&
          edu.fDiscount !== undefined &&
          edu.fDiscount) ||
        0,
      onlineFDiscount:
        (edu.onlineFDiscount !== null &&
          edu.onlineFDiscount !== undefined &&
          edu.onlineFDiscount) ||
        0,
      fDays: (edu.fDays !== null && edu.fDays !== undefined && edu.fDays) || 0,
      onlineFDays:
        (edu.onlineFDays !== null &&
          edu.onlineFDays !== undefined &&
          edu.onlineFDays) ||
        0,
      payoutTo: edu.fulfilmentType || 'center',
      onlineCorporatePayout: edu.onlineCorporatePayout || 0,
      onlineRetailPayout: edu.onlineRetailPayout || 0,
      telehealth: edu.telehealth || false,
      previousTelehealth: edu.telehealth || false,
      previousDoctorPracticeActive: edu.active === 1,
      previousData: edu,
    });
  };

  showPriceHistory = (edu) => {
    console.log('shgsf');
    getDoctorPriceHistory(this.doctorId, edu.centerId)
      .then((response) => {
        console.log(response);
        this.setState({
          doctorPriceHistory: response.priceHistory,
          showingPriceHistory: true,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ formSaving: false });
      });
  };

  componentDidUpdate = () => {
    if (document.getElementById('edit-form')) {
      document.getElementById('edit-form').scrollIntoView();
    }
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorPracticeId: null,
      networkCenterId: null,
      doctorPracticeActive: '',
      networkCenterTitle: '',
      networkCenterAddress: '',
      networkCenterLocality: '',
      emergencyNumber: '',
      description: '',
      opdCharges: '',
      onlineOpdCharges: '',
      previousOnlineOpdCharges: '',
      previousOpdCharges: '',
      priceChangeReason: '',
      latitude: '',
      longitude: '',
      onlineFDiscountOperation: 'percentage',
      onlineFDiscount: '',
      onlineFDays: '0',
    });
  };

  onFromToDateChange = (date, dateString) => {
    console.log({ date, dateString });
    this.setState({
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };

  onPracticeActiveChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      doctorPracticeActive: e.target.checked,
    });
  };

  onRequestFromPluton = (e) => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      isRequestFromPluton: e.target.checked,
    });
  };

  onTelehealthActiveChange = (e) => {
    this.setState({
      telehealth: e.target.checked,
    });
  };

  removePractice = (edu) => {
    Modal.confirm({
      title: 'Confirm Removal',
      content: `Are you sure you want to remove ${edu.centerName} for this doctor?`,
      onOk: () => {
        this.setState({ formSaving: true });
        removePracticeForDoctor(this.doctorId, edu.centerId)
          .then(() => {
            this.fetchPractice();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.setState({ formSaving: false });
          });
      },
    });
  };

  fetchHealthCenters = (val) => {
    this.setState({ fetchingCenters: true });
    if (val.trim() === '') {
      this.setState({
        fetchedHealthCenters: [],
        fetchingCenters: false,
      });
      return;
    }
    fetchCenters(val)
      .then((result) => {
        this.setState({
          fetchedHealthCenters: result.result.map((ele) => ({
            key: ele.centerId,
            locality: ele.locality,
            label: ele.title,
          })),
        });
      })
      .finally(() => {
        this.setState({
          fetchingCenters: false,
        });
      });
  };

  openPracticeProfile = (centerId) => () => {
    const { history } = this.props;
    history.push(`/center-profile/${centerId}`);
  };


  render() {
    const {
      addedHealthCenter,
      fetchedHealthCenters,
      fetchingCenters,
      loading,
      practiceCenters,
      networkCenterTitle,
      networkCenterLocality,
      networkCenterStatus,
      opdCharges,
      onlineOpdCharges,
      previousOnlineOpdCharges,
      previousOpdCharges,
      priceChangeReason,
      offlineDiscountOperation,
      offlineDiscount,
      onlineDiscountOperation,
      onlineDiscount,
      fDiscountOperation,
      fDiscount,
      fDays,
      onlineFDiscountOperation,
      onlineFDiscount,
      onlineFDays,
      payoutTo,
      formSaving,
      onlineRetailPayout,
      onlineCorporatePayout,
      telehealth,
      doctorPracticeActive,
      previousTelehealth,
      previousDoctorPracticeActive,
      addingNewCenter,
      previousData,
      showingPriceHistory,
    } = this.state;

    const practiceCentersForm = () => {
      const offlineDiscountType = (
        <Select
          value={offlineDiscountOperation}
          onChange={(e) => this.setState({ offlineDiscountOperation: e })}
        >
          <Option value="percentage">Percentage</Option>
          <Option value="fixed">Fixed Value</Option>
        </Select>
      );
      const onlineDiscountType = (
        <Select
          value={onlineDiscountOperation}
          onChange={(e) => this.setState({ onlineDiscountOperation: e })}
        >
          <Option value="percentage">Percentage</Option>
          <Option value="fixed">Fixed Value</Option>
        </Select>
      );
      const fDiscountType = (
        <Select
          value={fDiscountOperation}
          onChange={(e) => this.setState({ fDiscountOperation: e })}
        >
          <Option value="percentage">Percentage</Option>
          <Option value="fixed">Fixed Value</Option>
        </Select>
      );
      const onlineFDiscountType = (
        <Select
          value={onlineFDiscountOperation}
          onChange={(e) => this.setState({ onlineFDiscountOperation: e })}
        >
          <Option value="percentage">Percentage</Option>
          <Option value="fixed">Fixed Value</Option>
        </Select>
      );
      return (
        <Card id="edit-form">
          <BodyContainer>
            <Row gutter={24}>
              <Col xs={24} md={12}>
                <LabelText>Network Center Name</LabelText>
                {networkCenterTitle === '' ? (
                  <Select
                    autoFocus
                    style={{ width: '100%' }}
                    labelInValue
                    filterOption={false}
                    value={addedHealthCenter}
                    placeholder="Search for a health center"
                    notFoundContent={
                      fetchingCenters ? <Spin size="small" /> : null
                    }
                    showSearch
                    onSearch={this.debouncedFetchHealthCenters}
                    onChange={(e, opt) => {
                      console.log(opt);
                      this.setState({
                        networkCenterId: Number.parseFloat(e.key),
                        networkCenterTitle: e.label,
                        networkCenterLocality: opt.props.locality,
                      });
                    }}
                  >
                    {fetchedHealthCenters.map((d) => (
                      <Option key={d.key} locality={d.locality}>
                        {d.label} ({d.locality})
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <AntInput
                    disabled
                    value={networkCenterTitle}
                    placeholder="Network Center Title"
                  />
                )}
              </Col>

              <Col xs={24} md={12}>
                <LabelText>Network Center Locality</LabelText>
                <AntInput
                  disabled
                  value={networkCenterLocality}
                  placeholder="Locality"
                />
              </Col>

              <Col xs={24} md={12}>
                <LabelText>OPD Charges</LabelText>
                <AntInput
                  value={opdCharges}
                  onChange={(e) => {
                    console.log({ value: e.target.value });
                    this.setState({
                      opdCharges: Number.parseFloat(e.target.value) || 0,
                    });
                  }}
                  placeholder="OPD Charges"
                />
              </Col>
              <Col xs={24} md={12}>
                <LabelText>Online OPD Charges</LabelText>
                <AntInput
                  value={onlineOpdCharges}
                  onChange={(e) => {
                    console.log({ value: e.target.value });
                    this.setState({
                      onlineOpdCharges: Number.parseFloat(e.target.value) || 0,
                    });
                  }}
                  placeholder="Online OPD Charges"
                />
              </Col>

              <Col xs={24} md={12}>
                <LabelText>Offline Discount</LabelText>
                <AntInput
                  value={offlineDiscount}
                  addonBefore={offlineDiscountType}
                  onChange={(e) => {
                    this.setState({
                      offlineDiscount: Number.parseFloat(e.target.value) || 0,
                    });
                  }}
                  placeholder="Offline Discount"
                />
              </Col>

              <Col xs={24} md={12}>
                <LabelText>Online Discount</LabelText>
                <AntInput
                  value={onlineDiscount}
                  addonBefore={onlineDiscountType}
                  onChange={(e) => {
                    this.setState({
                      onlineDiscount: Number.parseFloat(e.target.value) || 0,
                    });
                  }}
                  placeholder="Online Discount"
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={24} md={12}>
                <LabelText>Follow up Discount</LabelText>
                <AntInput
                  value={fDiscount}
                  addonBefore={fDiscountType}
                  onChange={(e) => {
                    this.setState({
                      fDiscount: Number.parseFloat(e.target.value) || 0,
                    });
                  }}
                  placeholder="Follow up Discount"
                />
              </Col>
              <Col xs={24} md={12}>
                <LabelText>Online Follow up Discount</LabelText>
                <AntInput
                  value={onlineFDiscount}
                  addonBefore={onlineFDiscountType}
                  onChange={(e) => {
                    this.setState({
                      onlineFDiscount: Number.parseFloat(e.target.value) || 0,
                    });
                  }}
                  placeholder="Online Follow up Discount"
                />
              </Col>
              <Col xs={24} md={12}>
                <LabelText>Follow up Days</LabelText>
                <AntInput
                  value={fDays}
                  onChange={(e) => {
                    this.setState({
                      fDays: Number.parseInt(e.target.value) || 0,
                    });
                  }}
                  placeholder="Follow up Days"
                />
              </Col>
              <Col xs={24} md={12}>
                <LabelText>Online Follow up Days</LabelText>
                <AntInput
                  value={onlineFDays}
                  onChange={(e) => {
                    this.setState({
                      onlineFDays: Number.parseInt(e.target.value) || 0,
                    });
                  }}
                  placeholder="Online Follow up Days"
                />
              </Col>
              <Col xs={24} md={12}>
                <LabelText>Payout To</LabelText>
                <Select
                  style={{ width: '100%' }}
                  value={payoutTo}
                  onChange={(e) => {
                    this.setState({ payoutTo: e });
                  }}
                >
                  <Option value="doctor">Doctor</Option>
                  <Option value="center">Center</Option>
                </Select>
              </Col>
              
              <Col xs={24} md={12}>
                <LabelText>Onboarding Status</LabelText>
                <Select
                  style={{ width: '100%' }}
                  value={networkCenterStatus}
                  onChange={(e) => {
                    this.setState({ networkCenterStatus: e });
                  }}
                >
                  <Option value="not-live">Not Live</Option>
                  <Option value="pending">Pending</Option>
                  <Option value="live">Live</Option>
                </Select>
              </Col>
              {!(
                addingNewCenter ||
                previousDoctorPracticeActive !== doctorPracticeActive ||
                previousTelehealth !== telehealth
              ) && (
                  <Col xs={24} md={24}>
                    <LabelText>Reason for Doctor details Change</LabelText>
                    <Select
                      style={{ width: '100%', marginBottom: '10px' }}
                      // value={priceChangeReason}
                      defaultValue="Select Reason"
                      onChange={(e) => {
                        this.setState({
                          priceChangeReason: e,
                        });
                      }}
                    >
                      <Option value="Fee got revised">Fee got revised</Option>
                      <Option value="Incorrect fee was updated in our system">
                        Incorrect fee was updated in our system
                      </Option>
                      <Option value="Incorrect price was informed by the centre while booking the appointment">
                        Incorrect price was informed by the centre while booking
                        the appointment
                      </Option>
                      <Option value="Other">Other</Option>
                    </Select>
                    {priceChangeReason === 'Other' ? (
                      <AntInput
                        value={this.state.inputReason}
                        onChange={(e) => {
                          this.setState({
                            inputReason: e.target.value,
                          });
                        }}
                        placeholder="Please Enter your reason for Changing Doctor details"
                      />
                    ) : null}
                  </Col>
                )}
              {telehealth ? (
                <React.Fragment>
                  <Col xs={24} md={12}>
                    <LabelText>Online Retail Payout</LabelText>
                    <AntInput
                      value={onlineRetailPayout}
                      onChange={(e) => {
                        this.setState({
                          onlineRetailPayout:
                            Number.parseInt(e.target.value) || 0,
                        });
                      }}
                      placeholder="Follow up Days"
                    />
                  </Col>
                  <Col xs={24} md={12}>
                    <LabelText>Online Corporate Payout</LabelText>
                    <AntInput
                      value={onlineCorporatePayout}
                      onChange={(e) => {
                        this.setState({
                          onlineCorporatePayout:
                            Number.parseInt(e.target.value) || 0,
                        });
                      }}
                      placeholder="Follow up Days"
                    />
                  </Col>
                </React.Fragment>
              ) : null}
            </Row>
            <Row>
              <Col span={12}>
                <Checkbox
                  style={{ marginTop: 10, marginBottom: 10 }}
                  checked={this.state.doctorPracticeActive}
                  onChange={this.onPracticeActiveChange}
                >
                  Practice Center Active
                </Checkbox>
              </Col>
              <Col span={12}>
                <Checkbox
                  style={{ marginTop: 10, marginBottom: 10 }}
                  checked={telehealth}
                  onChange={this.onTelehealthActiveChange}
                >
                  Telehealth?
                </Checkbox>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col xs={24} md={12}>
                <Button
                  type="primary"
                  block
                  style={{ marginRight: 10 }}
                  onClick={this.submit}
                >
                  {addingNewCenter ||
                    previousDoctorPracticeActive !== doctorPracticeActive ||
                    previousTelehealth !== telehealth ||
                    previousOnlineOpdCharges !== onlineOpdCharges ||
                    previousData.onlineDiscount !== onlineDiscount ||
                    previousData.onlineDiscountOperation !==
                    onlineDiscountOperation ||
                    previousData.onlineFDiscount !== onlineFDiscount ||
                    previousData.onlineFDiscountOperation !==
                    onlineFDiscountOperation ||
                    previousData.onlineFDays !== onlineFDays
                    ? 'Submit'
                    : 'Send for approval'}
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Button block onClick={this.cancelEditing}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </BodyContainer>
        </Card>
      );
    };
    const renderPractice = (edu, idx) => {
      let statusColor = '#ffaf3c';
      switch (edu.status) {
        case 'not-live':
          statusColor = '#fe823a';
          break;
        case 'live':
          statusColor = '#00b7b7';
          break;
        case 'pending':
          statusColor = '#ffaf3c';
          break;
        default:
          break;
      }
      const renderStatus = (status) => {
        switch (status) {
          case 'not-live':
            return 'Not Live';
          case 'live':
            return 'Live';
          case 'pending':
            return 'Pending';
          default:
            return 'Pending';
        }
      };
      return (
        <Col key={idx} span={24}>
          <Card>
            <EduRowComponent>
              <Row type="flex" align="middle" justify="space-between">
                <Col>
                  <Row type="flex" align="middle" gutter={[16, 16]}>
                    <Col>
                      <Title level={4} style={{ margin: 0 }}>
                        {edu.centerName}
                      </Title>
                    </Col>
                    <Col>
                      <Button
                        icon="edit"
                        onClick={this.openPracticeProfile(edu.centerId)}
                      >
                        Want to edit center fulfilment? Edit Center
                      </Button>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row type="flex" align="middle">
                    <StatusDot color={statusColor} />
                    <Text
                      strong
                      style={{
                        color: statusColor,
                        marginLeft: '8px',
                      }}
                    >
                      {renderStatus(edu.status)}
                    </Text>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Paragraph strong style={{ margin: 0 }}>
                    {edu.centerLocation}
                  </Paragraph>
                </Col>
              </Row>
              <Row style={{ marginBottom: '8px' }}>
                <Col span={12}>
                  <PracticeText as="span">
                    OPD Charges: <Text strong>{` ₹ ${edu.opdCharges}`}</Text>
                  </PracticeText>
                </Col>
                <Col span={12}>
                  <PracticeText as="span">
                    Online OPD Charges:{' '}
                    <Text strong>{` ₹ ${edu.onlineOpdCharges}`}</Text>
                  </PracticeText>
                </Col>
              </Row>
              <Row style={{ marginBottom: '8px' }}>
                <Col span={24}>
                  <Row>
                    <Col span={12}>
                      <Title level={4} strong>
                        Paying to:{' '}
                        {edu.fulfilmentType === 'center'
                          ? " Center's Account"
                          : " Doctor's Account"}
                      </Title>
                    </Col>
                    <Col span={12}>
                      <Row>
                        <Col>
                          <a
                            href={edu.inviteLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {edu.inviteLink}
                          </a>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Text code>{edu.slug}</Text>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row
                style={{ marginBottom: '8px' }}
                type="flex"
                align="middle"
                justify="space-between"
              >
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Offline Discount:</Text>
                      <Text>
                        {edu.offlineDiscountOperation === 'percentage'
                          ? ` ${edu.offlineDiscount}%`
                          : ` ₹ ${edu.offlineDiscount}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Online Discount:</Text>
                      <Text>
                        {edu.onlineDiscountOperation === 'percentage'
                          ? ` ${edu.onlineDiscount}%`
                          : ` ₹ ${edu.onlineDiscount}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row
                style={{ marginBottom: '8px' }}
                type="flex"
                align="middle"
                justify="space-between"
              >
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Followup Discount:</Text>
                      <Text>
                        {edu.fDiscountOperation === 'percentage'
                          ? ` ${edu.fDiscount}%`
                          : ` ₹ ${edu.fDiscount}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Online Followup Discount:</Text>
                      <Text>
                        {edu.onlineFDiscountOperation === 'percentage'
                          ? ` ${edu.onlineFDiscount}%`
                          : ` ₹ ${edu.onlineFDiscount}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row
                style={{ marginBottom: '8px' }}
                type="flex"
                align="middle"
                justify="space-between"
              >
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Followup Days:</Text>
                      <Text>{edu.fDays}</Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Online Followup Days:</Text>
                      <Text>{edu.onlineFDays}</Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ marginBottom: '8px' }}>
                <Col span={12}>
                  <Text strong>Is Doctor active in center?</Text>
                  <Text>{edu.active === 1 ? ' Yes' : ' No'}</Text>
                </Col>
                <Col span={12}>
                  <Text strong>Online Practice Active?</Text>
                  <Text>{edu.telehealth === 1 ? ' Yes' : ' No'}</Text>
                </Col>
              </Row>
              {edu.lastPrice && (
                <Row style={{ marginBottom: '8px' }}>
                  <Col span={12}>
                    <Text strong>Previous Price for Doctor:</Text>
                    <Text>{edu.lastPrice}</Text>
                  </Col>
                  <Col span={12}>
                    <Text strong>Last Updated:</Text>
                    <Text>
                      {edu.priceLastUpatedDate
                        ? new Date(edu.priceLastUpatedDate).toLocaleDateString()
                        : ''}
                    </Text>
                  </Col>
                </Row>
              )}
              <Row
                style={{
                  marginBottom: '10px',
                }}
              >
                <Col span={6}>
                  {showingPriceHistory ? (
                    <Button
                      block
                      type="primary"
                      style={{ marginRight: 10 }}
                      onClick={() =>
                        this.setState({
                          showingPriceHistory: false,
                        })
                      }
                    >
                      Close Price History Table
                    </Button>
                  ) : (
                    <Button
                      block
                      type="primary"
                      style={{ marginRight: 10 }}
                      onClick={() => this.showPriceHistory(edu)}
                    >
                      Show Doctor Price History
                    </Button>
                  )}
                </Col>
              </Row>
              {showingPriceHistory && (
                <Table
                  dataSource={this.state.doctorPriceHistory}
                  columns={columns}
                />
              )}
            </EduRowComponent>
            <Row gutter={24}>
              <Col xs={24} md={12}>
                <Button
                  block
                  type="primary"
                  style={{ marginRight: 10 }}
                  onClick={() => this.editPractice(edu)}
                >
                  Edit Charges
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Button
                  block
                  type="danger"
                  style={{ marginRight: 10 }}
                  onClick={() => this.removePractice(edu)}
                >
                  Remove practice for doctor
                </Button>
              </Col>
              {/* <Popconfirm
            department="Are you sure delete this?"
            onConfirm={() => this.deletePractice(edu.doctorPracticeId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No">
            <Button type="danger">Delete</Button>
          </Popconfirm> */}
            </Row>
          </Card>
        </Col>
      );
    };

    return (
      <Row type="flex" align="middle" gutter={[16, 16]}>
        {formSaving ? (
          <Spin spinning={formSaving} />
        ) : (
          <React.Fragment>
            <Col span={24}>
              <Title type={2}>Practice Centers</Title>
            </Col>
            {loading ? (
              <div>
                <Spin />
              </div>
            ) : (
              <Col span={24}>{practiceCenters.map(renderPractice)}</Col>
            )}
            {!this.state.formEditing && (
              <Col span={24}>
                <Button
                  style={{ alignSelf: 'center', flex: 0, padding: 4 }}
                  onClick={() => {
                    this.editPractice({});
                    this.setState({ addingNewCenter: true });
                  }}
                >
                  Add Practice Center
                </Button>
              </Col>
            )}
            <Col span={24}>
              {this.state.formEditing && practiceCentersForm()}
            </Col>
          </React.Fragment>
        )}
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default withRouter(connect(mapStateToProps)(DoctorPracticeCenterScreen));
